var _defs, _g, _path, _path2, _g2, _text, _text2, _g3, _line, _line2, _line3, _line4, _text3, _g4, _g5, _g6, _g7, _g8, _g9, _path3, _rect, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMerchantSignUp3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e39435;\n      }\n\n      .cls-2 {\n        fill: #37474f;\n      }\n\n      .cls-3 {\n        fill: #ee2554;\n      }\n\n      .cls-4 {\n        isolation: isolate;\n      }\n\n      .cls-4, .cls-5, .cls-6 {\n        opacity: .2;\n      }\n\n      .cls-7 {\n        font-size: 35.29px;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10 {\n        fill: #f9cf56;\n      }\n\n      .cls-7, .cls-8, .cls-11, .cls-10, .cls-12 {\n        font-weight: 700;\n      }\n\n      .cls-7, .cls-8, .cls-10 {\n        font-family: PalatinoLinotype-Bold, 'Palatino Linotype';\n      }\n\n      .cls-13 {\n        opacity: .3;\n      }\n\n      .cls-14 {\n        letter-spacing: -.06em;\n      }\n\n      .cls-15, .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-16 {\n        fill: #031547;\n      }\n\n      .cls-17 {\n        fill: #00728c;\n      }\n\n      .cls-18, .cls-19, .cls-6 {\n        fill: none;\n      }\n\n      .cls-20 {\n        fill: #1a2e35;\n      }\n\n      .cls-19 {\n        stroke: #e5e5e6;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-19, .cls-6 {\n        stroke-linecap: round;\n      }\n\n      .cls-8 {\n        font-size: 23.54px;\n      }\n\n      .cls-21 {\n        fill: #007cff;\n      }\n\n      .cls-22 {\n        fill: #fc5652;\n      }\n\n      .cls-6 {\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: .5px;\n      }\n\n      .cls-11 {\n        font-size: 12.54px;\n      }\n\n      .cls-11, .cls-12 {\n        font-family: Arial-BoldMT, Arial;\n      }\n\n      .cls-10 {\n        font-size: 35.46px;\n      }\n\n      .cls-23 {\n        fill: #b6b8ba;\n      }\n\n      .cls-12 {\n        fill: #444545;\n        font-size: 9.44px;\n      }\n\n      .cls-24 {\n        fill: #cd7a63;\n      }\n\n      .cls-25 {\n        fill: #b94d3c;\n      }\n\n      .cls-26 {\n        fill: #76b041;\n      }\n\n      .cls-27 {\n        fill: #a3194e;\n      }\n\n      .cls-28 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-29 {\n        fill: #f7f7f7;\n      }\n\n      .cls-30 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-31 {\n        fill: #db6e31;\n      }\n\n      .cls-32 {\n        fill: #ee2638;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M344.35,396.78l-180.46-.21c-2.6,0-4.7-2.11-4.7-4.71l.42-353.02c0-2.6,2.11-4.7,4.71-4.7l180.46.21c2.6,0,4.7,2.11,4.7,4.71l-.42,353.02c0,2.6-2.11,4.7-4.71,4.7Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M343.46,404.86l-178.47-.21c-7.64,0-13.83-6.21-13.83-13.86l.42-350.84c0-7.64,6.21-13.83,13.86-13.83l178.47.21c7.64,0,13.83,6.21,13.83,13.86l-.42,350.84c0,7.64-6.21,13.83-13.86,13.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M361.26,103.42v14.23c0,1.57-.91,2.99-2.34,3.64l-2.4,1.1v-23.72l2.4,1.1c1.42.65,2.34,2.08,2.34,3.64Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.41,109.31v-14.23c0-1.57.91-2.99,2.34-3.64l2.4-1.1v23.72l-2.4-1.1c-1.42-.65-2.34-2.08-2.34-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M147.41,137.01v-14.23c0-1.57.91-2.99,2.34-3.64l2.4-1.1v23.72l-2.4-1.1c-1.42-.65-2.34-2.08-2.34-3.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M344.35,396.78l-180.46-.21c-2.6,0-4.7-2.11-4.7-4.71l.42-353.02c0-2.6,2.11-4.7,4.71-4.7l180.46.21c2.6,0,4.7,2.11,4.7,4.71l-.42,353.02c0,2.6-2.11,4.7-4.71,4.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "305.87 341.23 206.13 341.23 6 489.18 506 489.18 305.87 341.23"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M195.17,30.15h118.33v7.22c0,6.06-4.92,10.98-10.98,10.98h-96.38c-6.06,0-10.98-4.92-10.98-10.98v-7.22h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M271.11,40.61h-44.34c-.76,0-1.37-.61-1.37-1.37h0c0-.76.61-1.37,1.37-1.37h44.34c.76,0,1.37.61,1.37,1.37h0c0,.76-.61,1.37-1.37,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M283.26,39.24c0,1.61-1.3,2.91-2.91,2.91s-2.91-1.3-2.91-2.91,1.3-2.91,2.91-2.91,2.91,1.3,2.91,2.91Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M256,154.44h0c-27.54,0-49.87,22.33-49.87,49.87v136.92h99.75v-136.92c0-27.54-22.33-49.87-49.87-49.87Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M150.69,302.42l8.04,3.17-8.04,3.17c-2.79,1.1-5,3.31-6.1,6.1l-3.17,8.04-3.17-8.04c-1.1-2.79-3.31-5-6.1-6.1l-8.04-3.17,8.04-3.17c2.79-1.1,5-3.31,6.1-6.1l3.17-8.04,3.17,8.04c1.1,2.79,3.31,5,6.1,6.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M141.2,416.59l5.79,2.28-5.79,2.28c-2.01.79-3.6,2.39-4.4,4.4l-2.28,5.79-2.28-5.79c-.79-2.01-2.39-3.6-4.4-4.4l-5.79-2.28,5.79-2.28c2.01-.79,3.6-2.39,4.4-4.4l2.28-5.79,2.28,5.79c.79,2.01,2.39,3.6,4.4,4.4Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M178.61,144.55l-38.02.15c-2.35,0-4.24,1.92-4.23,4.27l.09,23.56c0,2.35,1.92,4.24,4.27,4.23l15.52-.06-.1,6.98h3.62s3.46-7,3.46-7l15.52-.06c2.35,0,4.24-1.92,4.23-4.27l-.09-23.56c0-2.35-1.92-4.24-4.27-4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M174.99,144.56l-38.02.15c-2.35,0-4.24,1.92-4.23,4.27l.09,23.56c0,2.35,1.92,4.24,4.27,4.23l15.52-.06,3.52,6.96,3.46-6.99,15.52-.06c2.35,0,4.24-1.92,4.23-4.27l-.09-23.56c0-2.35-1.92-4.24-4.27-4.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M150.34,157.17c-.58-1.19-2.44-1.69-3.66-1.31-1.21.38-2.14,1.39-2.14,1.39,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.94-1-2.15-1.37-1.23-.37-3.08.14-3.65,1.33-.84,1.76.2,4.19,3.24,6.63,1.31,1.05,2.59,1.56,2.59,1.56,0,0,0,0,0,0,0,0,0,0,0,0,0,0,1.27-.51,2.58-1.58,3.03-2.46,4.05-4.9,3.19-6.65Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(152.39 165.16)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 0,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 6.22,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 12.94,
    y: 0
  }, "0"))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(126.86 48.32) rotate(-30.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(326.08 295.51) rotate(-20.26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-12",
    transform: "translate(316.48 67.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "LIVE")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 310.52,
    cy: 64.45,
    r: 3.59
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 294.16,
    y1: 64.45,
    x2: 179.41,
    y2: 64.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 220,
    y1: 73.61,
    x2: 179.41,
    y2: 73.61
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 284.67,
    y1: 73.61,
    x2: 231.33,
    y2: 73.61
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 231.33,
    y1: 82.77,
    x2: 179.41,
    y2: 82.77
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(186.4 105.28) rotate(23.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M106.73,79.93c4.9,17.81-5.56,36.22-23.36,41.12-17.81,4.9-36.22-5.56-41.12-23.36-4.9-17.81,5.56-36.22,23.36-41.12,17.81-4.9,36.22,5.56,41.12,23.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.08,73.74c-3.31-3.75-10.59-3.7-14.66-1.08-4.02,2.58-6.4,7.19-6.4,7.19,0,0-.02,0-.03-.02,0,.01-.02.03-.02.03,0,0-4.43-2.71-9.2-2.83-4.84-.13-11.08,3.6-11.97,8.53-1.31,7.25,4.91,15.06,18.47,20.9,5.84,2.52,11,3.07,11,3.07,0,0,.01-.02.02-.03.01,0,.03.01.03.01,0,0,4.12-3.15,7.82-8.33,8.56-12.02,9.83-21.92,4.95-27.45Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 405.64,
    cy: 256,
    r: 44.95,
    transform: "translate(-30.01 456.72) rotate(-56.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M437.08,249.15c-1.71-6.51-10.47-10.85-16.94-10.16-6.38.67-12.03,4.77-12.03,4.77,0,0-.02-.02-.03-.04-.01,0-.04.02-.04.02,0,0-3.68-5.93-9.34-8.96-5.73-3.08-15.49-2.38-19.53,3-5.95,7.92-3.2,21.06,9.54,36.26,5.49,6.55,11.35,10.34,11.35,10.34,0,0,.02-.01.04-.02,0,.01.03.03.03.03,0,0,6.86-1.29,14.42-5.28,17.54-9.26,25.05-20.38,22.53-29.96Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M437.55,164.64c-2.87,14.32-16.8,23.6-31.12,20.73-14.32-2.87-23.6-16.8-20.73-31.12,2.87-14.32,16.8-23.6,31.12-20.73,14.32,2.87,23.6,16.8,20.73,31.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.12,155.41c-1.01-3.83-6.16-6.38-9.97-5.98-3.75.4-7.08,2.8-7.08,2.8,0,0,0-.01-.02-.02,0,0-.02.01-.02.01,0,0-2.17-3.49-5.49-5.27-3.37-1.81-9.11-1.4-11.49,1.77-3.5,4.66-1.88,12.38,5.61,21.32,3.23,3.85,6.68,6.08,6.68,6.08,0,0,.01,0,.02-.01,0,0,.02.02.02.02,0,0,4.03-.76,8.48-3.1,10.32-5.44,14.73-11.99,13.25-17.62Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M140.77,131.3c-1.71,11.14-12.13,18.79-23.27,17.07-11.14-1.71-18.79-12.13-17.07-23.27,1.71-11.14,12.13-18.79,23.27-17.07,11.14,1.71,18.79,12.13,17.07,23.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M134.71,124.45c-.91-2.92-4.97-4.7-7.89-4.26-2.88.44-5.36,2.41-5.36,2.41,0,0,0,0-.01-.02,0,0-.02.01-.02.01,0,0-1.79-2.61-4.42-3.87-2.66-1.28-7.07-.76-8.8,1.76-2.54,3.71-1.02,9.62,5.07,16.25,2.63,2.86,5.36,4.45,5.36,4.45,0,0,.01,0,.02,0,0,0,.01.01.01.01,0,0,3.08-.73,6.43-2.69,7.77-4.56,10.94-9.76,9.61-14.05Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M127.64,175.73c3.79,8.93-.37,19.24-9.3,23.03-8.93,3.79-19.24-.37-23.03-9.3-3.79-8.93.37-19.24,9.3-23.03,8.93-3.79,19.24.37,23.03,9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M120.1,173.46c-1.99-1.72-5.77-1.19-7.71.46-1.91,1.62-2.83,4.19-2.83,4.19,0,0-.01,0-.02,0,0,0,0,.02,0,.02,0,0-2.49-1.1-4.99-.83-2.53.27-5.52,2.65-5.64,5.27-.17,3.86,3.61,7.5,11.07,9.59,3.22.9,5.94.83,5.94.83,0,0,0,0,0-.01,0,0,.02,0,.02,0,0,0,1.93-1.93,3.49-4.88,3.62-6.85,3.59-12.1.67-14.63Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M147.2,224.2c-1.86,7.26-9.25,11.64-16.51,9.78s-11.64-9.25-9.78-16.51,9.25-11.64,16.51-9.78c7.26,1.86,11.64,9.25,9.78,16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.64,219.27c-.41-1.99-2.98-3.44-4.95-3.33-1.93.1-3.7,1.25-3.7,1.25h0s-.01,0-.01,0c0,0-1.02-1.84-2.67-2.85-1.68-1.02-4.63-.96-5.93.6-1.92,2.29-1.3,6.3,2.3,11.08,1.55,2.06,3.26,3.3,3.26,3.3,0,0,0,0,.01,0,0,0,0,0,0,0,0,0,2.09-.28,4.43-1.36,5.44-2.51,7.87-5.75,7.27-8.67Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M398.4,208.84l5.67,2.23-5.67,2.23c-1.97.78-3.53,2.33-4.3,4.3l-2.23,5.67-2.23-5.67c-.78-1.97-2.33-3.53-4.3-4.3l-5.67-2.23,5.67-2.23c1.97-.78,3.53-2.33,4.3-4.3l2.23-5.67,2.23,5.67c.78,1.97,2.33,3.53,4.3,4.3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 6,
    y: -10.82,
    width: 500,
    height: 500
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M226.76,151.03l-27.25,22.05-3.87-35.48h-9.76s-1.07,35.67-1.23,40.11c-.15,4.29.61,8.47,1.94,11.93,2.21,5.74,9.21,7.92,14.4,4.62l32.75-20.8,6.89-28.31-5.4,1.31c-3.09.98-5.96,2.52-8.48,4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M195.68,138.68s3.16-2.73,3.39-6.17c.23-3.44,1.33-6.13,1.32-8.7,0-2.57-2.26.07-3.18,1.72-.92,1.65-1.97,3.51-3.09,2.62-1.12-.88-5.67-12.3-7.36-13.35-1.69-1.05-1.53,1.03-1.53,1.03,0,0-1.18-2.74-2.39-2.56-.32.05-.98.67-.63,2,.77,3,2.71,9.22,2.71,9.22-.1-.36-3.05-7.86-3.63-8.93-.77-1.39-1.84-1.65-2.63-1.18-1.13.68,2.2,10.11,2.06,10.6,0,0-1.74-5.49-3.4-5.81-1.66-.32-.76,3.2.63,6.15,1.27,2.7,3.05,8.34,4.61,10.96,1.92,3.23,3.93,4.96,7.44,4.55,3.5-.41,5.7-2.17,5.7-2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M199.51,173.09s.64,2.55,0,5.83c0,0,4.25-3.67,3.17-8.4l-3.17,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.16,115.76c1.25,2.29,2.38,4.64,3.39,7.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.6,128.2c2.03-1.56,4.29-2.81,6.69-3.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "301.02 486.67 288.39 487.91 281.49 455.67 301.02 453.85 301.02 486.67"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M286.56,482.33h4.51c1.02,0,1.96.52,2.57,1.34,2.6,3.55,4.55,2.21,7.38-1.13,1.8-.21,2.28,1.85,2.43,2.41l3.37,12.26c.29,1.02-.3,2.09-1.32,2.38-.18.05-.37.08-.56.07h-35.72c-5.68,0-6.86-5.72-4.52-6.25,10.52-2.33,17.97-5.42,21.23-8.48.6-.54-.02-.94.64-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M279.84,486.51c1.42-.03,2.84-.22,4.22-.54.13-.05.2-.19.15-.32-.03-.07-.08-.13-.15-.15-.63-.31-6.27-2.94-7.68-1.94-.26.17-.41.48-.37.79,0,.58.29,1.13.77,1.47.92.55,1.99.79,3.06.69ZM283.18,485.63c-1.66.31-4.75.72-6.03-.24-.33-.26-.54-.65-.56-1.07-.03-.13.03-.27.15-.34.78-.54,4.11.62,6.45,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M284,485.98c.06.02.12.02.18,0,.08-.07.1-.17.07-.26,0-.24-1.32-5.78-4.42-5.43-.77.1-.99.47-1.02.78-.19,1.47,3.36,4.25,5.05,4.96l.13-.04ZM280.15,480.73c1.96,0,3.09,3.24,3.47,4.53-1.84-.97-4.42-3.28-4.25-4.18,0-.07,0-.28.57-.34h.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M283.43,485.81c1.55.21,2.99,1.14,3.83,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M280.63,487.92c1.55.21,2.99,1.14,3.83,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M277.14,489.69c1.55.21,2.99,1.14,3.83,2.47"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "239.82 485.69 227.19 486.93 221.35 454.58 239.29 452.63 239.82 485.69"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M225.36,481.35h4.51c1.02,0,1.96.52,2.57,1.34,2.6,3.55,4.55,2.21,7.38-1.13,1.8-.21,2.28,1.85,2.43,2.41l3.37,12.26c.29,1.02-.3,2.09-1.32,2.38-.18.05-.37.08-.56.07h-35.72c-5.68,0-6.86-5.72-4.52-6.25,10.52-2.33,17.97-5.42,21.23-8.48.6-.54-.02-.94.64-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M218.64,485.53c1.42-.03,2.84-.22,4.22-.54.13-.05.2-.19.15-.32-.03-.07-.08-.13-.15-.15-.63-.31-6.27-2.94-7.68-1.94-.26.17-.41.48-.37.79,0,.58.29,1.13.77,1.47.92.55,1.99.79,3.06.69ZM221.98,484.65c-1.66.31-4.75.72-6.03-.24-.33-.26-.54-.65-.56-1.07-.03-.13.03-.27.15-.34.78-.54,4.11.62,6.45,1.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M222.81,485c.06.02.12.02.18,0,.08-.07.1-.17.07-.26,0-.24-1.32-5.78-4.42-5.43-.77.1-.99.47-1.02.78-.19,1.47,3.36,4.25,5.05,4.96l.13-.04ZM218.95,479.75c1.96,0,3.09,3.24,3.47,4.53-1.84-.97-4.42-3.28-4.25-4.18,0-.07,0-.28.57-.34h.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M222.23,484.83c1.55.21,2.99,1.14,3.83,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M219.43,486.94c1.55.21,2.99,1.14,3.83,2.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M215.95,488.72c1.55.21,2.99,1.14,3.83,2.47"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.51,246.39c-.91,2.7-11.11,89.06-10.99,107.7.1,15.08,11.77,116.83,11.77,116.83l21.98-.77s-1.13-50.22-.49-67.66c.64-17.43-3.55-50.2-3.55-50.2l26.3-78.64-.99-26.38-44.02-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.05,362.42c-.58-2.52-1.5-7.63-2.63-14.37.03,0,.07-.02.11-.02-.83-8.92,2.03-55.1-.79-81.48-2.17-16.8-6.18-25.73-10.5-31.3-.22-.29-.43-.55-.61-.78-.72-.9-1.15-1.39-1.15-1.39-.82.21-1.64.4-2.45.57-.3.07-.61.13-.91.2-30.53,6.38-56.37-2.76-56.37-2.76-2.81,6.94-4.34,24.15-6.39,39.5,3.19,3.5,15.62,6.76,31.69,9.77l4.58,20.73c2.41,12.86,5.51,25.46,8.14,36.82l2.75,12.44c.17.82.33,1.62.49,2.42,1.39,7.15,17.08,120.42,17.08,120.42l22.32.36s2.47-77.05-5.35-111.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M220.09,238.32s10.6,11.62,28.77,11.79c18.17.17,38.56-10.42,38.56-10.42l-2.28-3.91-52.33,5.7-10.77-5.7-1.95,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M253.63,306.24c.08.42-10.33-40.03-10.33-40.03,0,0-7.99,36.64,4.73,56.79l5.6-16.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M236.05,144.64c-11.31,5.82-25.78,18.11-25.78,18.11l12.86,22.76s26.51-18.05,23.71-24.72c-2.91-6.95-3.04-17.36-10.79-16.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.79,159.03c-1.42,2.43-1.91,3.81-2.8,6.6-.89,2.8-1.38,7.88-1.6,10.51l4.8,1.38c-.19-6.41-.21-12.08-.4-18.49Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M292.5,178.13l7.16-26.13c-4.99-7.45-28.97-13.96-28.97-13.96l-16.28.89s-6.26,1.4-11.61,3.14c-7.15,2.33-11.02,4.21-12.72,8.18,0,0-2.98,8.79-1.19,26.91.49,4.98-.07,30.88-1.46,39.44l-7.34,21.73c29.74,23.16,66.74-1.54,66.74-1.54-1.34-4.09-2.24-8.63-2.84-12.63.44-5.1-.17-12.96,1.99-21.89.42-1.72,5.8-22.45,6.52-24.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M290,185.52s-11.41-14.36-9.46-20.34l11.74,10.98-2.27,9.36Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M287.89,151.53c.73.49,6.39-2.36,12.69,5.42,5.64,6.98,32.54,34.67,31.66,44.39-.79,8.69-37.42,36.18-37.42,36.18l-6.05-8.37,23.94-29.59-22.67-20.51-2.16-27.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M295.01,148.65c6.44,1.42,17.71,17.93,17.71,17.93l-19.9,16.47s-12.41-14.71-11.37-23.12c.9-7.11,5.39-13.09,13.56-11.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.88,168.77c-.04-1.12.87-2.04,1.99-2.01,8.99.24,44.66.05,46.18,2.43,1.74,2.72-.92,37.74,2.06,41.11s6.54,2.9,6.54,2.9l-.2,7.74s-3.17-1.31-4.13,1.42c-.96,2.73,7.91,125.13,1.36,127.37-6.55,2.23-70.11,6.95-74.33,0-4.22-6.95,6.52-93.53,10.18-111.66,3.66-18.12,6.97-30.32,8.94-39.3,1.95-8.86,1.61-24.43,1.42-30Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.88,177.53s3.98-30.54,6.12-33.74c2.14-3.2,9.23-3.84,9.23-3.84,0,0-3.07,2.52-4.34,7.41-1.27,4.89-4.66,31.56-4.66,31.56l-6.35-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.21,175.35s6.1-33.07,14.59-35.4l6.37,2.12s-13.24,12.49-13.5,34.51l-7.46-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M223.33,252.21s30.33,2.45,42.81,0c0,0,1.23,25.86-4.24,30.55-6.24,5.35-37.24,8.03-38.61-6.47-.91-9.64.03-24.08.03-24.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M237.25,169.4c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12.5-1.12,1.12-1.12,1.12.5,1.12,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M269.28,169.4c0,.62-.5,1.12-1.12,1.12s-1.12-.5-1.12-1.12.5-1.12,1.12-1.12,1.12.5,1.12,1.12Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M308.78,133.91c-.96-1.5-2.77-2.38-4.35-3.38-6.03-3.8-9.46-10.15-11.22-16.56-1.76-6.4-2.08-13.04-3.31-19.54-.55-2.94-1.33-5.94-3.26-8.38-1.93-2.44-7.9-6.31-12.14-.73l-.02,9.47c-1.67,4.47-1.46,9.32-.86,14.01.6,4.68-2.66-2.54-2.89,2.17-.14,2.83.06,15.58,0,18.41-.07,2.83,3.86,7.73,5.63,10.08,2.22,2.95,6.15,4.53,10.05,5.24,5.05.92,10.37.59,15.23-.93,2.37-.74,4.71-1.81,6.26-3.58s2.14-4.34.9-6.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M274.58,84.58c2.5.44,4.47,2.48,5.53,4.79.7,1.54,1.07,3.27.78,4.93-.29,1.66-1.31,3.24-2.83,3.98-1.52.74-3.53.48-4.66-.77-1.02-1.14-1.18-2.83-.88-4.33.3-1.5.98-2.89,1.47-4.34.49-1.45.78-3.05.27-4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M274.5,139.07s-5.05,3.88-11.55,9.48c-1.35,1.17-2.84,2.18-4.42,3.01-4.26,2.26-6.1,1.68-7.15-.37-.23-.45-.74-1.74-.87-2.25-.89-3.44-2.25-5.6.53-7.81,3.13-2.49,4.64-4.63,4.08-8-.3-1.91-.99-3.89-1.8-5.81l2.47-2.88,12.9-13.02c-.32,8.69-.98,22.93,5.81,27.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M255.23,133.87c3.55-2.11,7.44-5.76,6.97-9.93-.21-1.76-.59-3.42-1.01-4.49l-7.21,9.54c.59,1.54.81,2.55,1.24,4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M272.34,97.45c-1.21,13.25-1.45,18.87-8.29,25.82-10.29,10.45-26.11,6.94-28.84-6.2-2.45-11.82-.05-31.51,12.95-37.08,12.82-5.49,25.38,4.2,24.17,17.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M255.83,101.63c-.07,1.24-.83,2.26-1.7,2.28-.87.02-1.52-.97-1.45-2.21.07-1.24.83-2.26,1.7-2.28.87-.02,1.52.97,1.45,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M242.1,101.44c-.07,1.2-.83,2.19-1.7,2.21-.87.02-1.52-.94-1.45-2.14.07-1.2.83-2.19,1.7-2.21.87-.02,1.52.94,1.45,2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M258.1,96.53c-.16.04-.34.02-.49-.09-2.28-1.59-4.47-.62-4.49-.61-.32.14-.69,0-.82-.33-.12-.33.04-.72.37-.87.11-.05,2.86-1.27,5.69.71.28.2.34.61.14.91-.1.15-.24.25-.4.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M237.41,96.1c-.15-.06-.27-.17-.34-.33-.13-.32.04-.69.38-.83,3.44-1.4,5.95.16,6.05.23.3.19.36.58.15.87-.22.29-.63.37-.93.18-.1-.06-2.06-1.24-4.8-.13-.18.07-.36.07-.52,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M266.69,105.77s-4.09-6.18-2.4-18.22c.28-2.02-.99-3.93-2.99-4.32-5.72-1.11-13.36-8.32-22.69,6,0,0,4.75-18.21,30.49-10.25,16.56,5.12,7.31,25.79,4.92,27.81-2.39,2.02-7.32-1.03-7.32-1.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M276.35,108.25c-1.57,2.72-4.11,4.42-6.44,5.01-3.51.88-5.32-4.76-4.12-8.27,1.08-3.16,4.52-5.26,7.94-4.57,3.36.68,4.41,4.73,2.62,7.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M245.66,101.08s-2.07,4.96-4.41,8.05c-.41.54-.16,1.33.48,1.56,1.64.6,3.55.06,3.55.06l.38-9.67Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M254.64,99.39l-3.04-.72s1.66,2.27,3.04.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M240.96,99.33l-3.04-.72s1.66,2.27,3.04.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M265.81,78.13c-11.61-7.81-23.71-1.15-23.71-1.15-13.88,8.06-7.74,21.64-7.74,21.64,9.7-5.14,14.44-7.1,23.75-12.47-2.18,3.48,1.52,8.38,5.59,11.97,4.07,3.59,2.88,5.17,2.88,5.17,11.02-12.06,10.83-17.34-.78-25.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M274.06,103.81c-.73-.59-1.83-.55-2.63-.08-.8.48-1.34,1.32-1.65,2.2-.37,1.06-.47,2.21-.26,3.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M246.1,114.54c1.04,1.49,2.33,4.39,2.33,4.39.28-.07.57-.14.85-.22,3.83-1.04,5.26-2.79,5.69-4.41.23-.89.15-1.75,0-2.42-.17-.78-.47-1.3-.47-1.3-1.7,1.76-5.2,3.01-7.09,3.6-.79.25-1.3.37-1.3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M247.4,114.16l.72,1.28c3.61-.99,6.01-2.17,6.84-3.57-.17-.78-.47-1.3-.47-1.3-1.7,1.76-5.2,3.01-7.09,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M249.28,118.7c3.83-1.04,5.26-2.79,5.69-4.41-1.29.4-2.8,1.04-4.02,2-.94.73-1.41,1.6-1.67,2.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M312.72,199.56s2.14-1.33,6.53-1.18c0,0-3.36-3.51-8.64-.73l2.11,1.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M289.85,230.6s-5.26-7.4-7.5-7.89c-2.24-.49-12.47.78-12.67,2.24-.19,1.46,1.36,1.65,1.36,1.65l-2.53,2.93s0,.88,1.17,1.07c0,0,.1,2.14,1.27,2.24,1.17.1,5.75-1.46,5.75-1.46l-3.8,2.63s-.58.97,2.34.68c2.92-.29,3.95-1.75,3.95-1.75,0,0,6.77,5.75,10.08,5.75s5.55-1.17,5.55-1.17l-4.97-6.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantSignUp3);
export default __webpack_public_path__ + "static/media/MerchantSignUp3.c9e447ccaeaa04087b675972b9976076.svg";
export { ForwardRef as ReactComponent };